<template>
  <PflegeBaseComponentTemplate
    v-editable="props.blok"
    :data-uid="props.blok._uid"
    :heading="props.blok.heading"
    :heading-tag="props.blok.headingTag"
    :text-align="props.blok.textAlign"
    :background-color="getPflegeColorName(props.blok.backgroundColor.value)"
    :subline="props.blok.subline"
    :subline-tag="props.blok.sublineTag"
    :color-splat="props.blok.colorSplat"
    :image-url="props.blok.imageUrl?.filename ?? undefined"
    :actions-alignment="props.blok.actionsAlignment"
    :heading-class="props.blok.headingClass"
    :subline-class="props.blok.sublineClass"
  >
    <template v-if="willRender(props.blok.content)" #default>
      <RichtextResolver :blok="props.blok.content" />
    </template>

    <template v-if="props.blok.actions?.length" #actions>
      <WPElementButton v-for="button in props.blok.actions" :key="button._uid" :blok="button" />
    </template>
  </PflegeBaseComponentTemplate>
</template>

<script setup lang="ts">
import { PflegeBaseComponentTemplate } from '@webcarelbj/shared-components'
import { inject } from 'vue'
import { RichtextResolver, WPElementButton } from '../'
import type { ButtonBlok } from '../'
import { BlokBaseComponentTemplate, BlokProps } from '../../types/blok'
import { blokMainComponent } from '../../types/injection-composables'
import { willRender, getPflegeColorName } from '../../utils'
import { DocContent } from '../../types/richtext'

export interface IntroComponentBlok extends Omit<BlokBaseComponentTemplate, 'actionsAlignment'> {
  headingTag?: '' | 'h1' | 'h2' | 'h3';
  headingClass?: '' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  subline?: string;
  sublineTag?: '' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  sublineClass?: '' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  actionsAlignment?: '' | 'flex-start' | 'center' | 'flex-end' | 'space-between';
  actions?: ButtonBlok[];
  content: DocContent;
  colorSplat?: boolean;
  imageUrl?: {
    filename: string | null;
  }
  // not used by this component, but defined in storyblok and used by the StepSection
  anchor?: string
}

const props = defineProps<BlokProps<IntroComponentBlok>>()

const mainComponent = inject(blokMainComponent, null)
if (mainComponent) {
  mainComponent.addHeadline(props.blok.heading!)
}
</script>
